"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _RangeFilter = _interopRequireDefault(require("../RangeFilter"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var payerClinicianPayerContractListConfig = function payerClinicianPayerContractListConfig(dataSource, handleUpdate) {
  var renderEditButton = function renderEditButton(key) {
    return function (_, record) {
      return /*#__PURE__*/_react.default.createElement(_components.Icon, {
        type: "edit-pencil",
        className: "cursor-pointer mt-[6px text-green1-55",
        onClick: function onClick() {
          return handleUpdate(record);
        }
      });
    };
  };
  var columns = [{
    title: 'First Name',
    dataIndex: 'clinician.firstName',
    key: 'clinician.firstName',
    sorter: (0, _utils.stringSorter)('clinician.firstName'),
    width: 150
  }, {
    title: 'Last Name',
    dataIndex: 'clinician.lastName',
    key: 'clinician.lastName',
    sorter: (0, _utils.stringSorter)('clinician.lastName'),
    width: 150
  }, {
    title: 'Email',
    dataIndex: 'clinician.email',
    key: 'clinician.email',
    sorter: (0, _utils.stringSorter)('clinician.email'),
    width: 150
  }, {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: (0, _utils.stringSorter)('status'),
    width: 150
  }, {
    title: 'Billing Taxonomy Code',
    dataIndex: 'clinicianBillingTaxonomyCode',
    key: 'clinicianBillingTaxonomyCode',
    sorter: (0, _utils.stringSorter)('clinicianBillingTaxonomyCode'),
    width: 150
  }, {
    title: 'Effective Date',
    dataIndex: 'effectiveDate',
    key: 'effectiveDate',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('effectiveDate'),
    render: function render(_, record) {
      return (0, _utils.formatDate)(record.effectiveDate, {
        utc: true
      });
    },
    sorter: (0, _utils.timeSorter)('effectiveDate'),
    width: 150
  }, {
    title: 'Edit Contract',
    dataIndex: 'clinicianPayerContracts',
    key: 'clinicianPayerContractsEdit',
    sorter: false,
    width: 150,
    render: renderEditButton()
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id'
  };
};
var _default = payerClinicianPayerContractListConfig;
exports.default = _default;